import type { TAsrResubmitModel } from 'app/queries/asrProxy/types/TAsrResubmitModel';

const SPEAKER_COUNT_OPTIONS = ['speakers_expected', 'speaker_options'];
const TWO_STAGE_CLUSTERING_UNSUPPORTED_MODEL = 'universal-3-5-pro';

export type TAsrModelCapabilities = {
  supportsSpeakerCount: boolean;
  supportsTwoStageClustering: boolean;
};

export const getAsrModelCapabilities = (model: TAsrResubmitModel | undefined): TAsrModelCapabilities => {
  if (!model) {
    return { supportsSpeakerCount: true, supportsTwoStageClustering: true };
  }

  const supportsSpeakerCount =
    model.supportedOptions === null
      ? model.supportsDiarization
      : model.supportedOptions.some((option) => SPEAKER_COUNT_OPTIONS.includes(option));
  const providerModel = `${model.provider} ${model.providerModel}`.toLowerCase();

  return {
    supportsSpeakerCount,
    supportsTwoStageClustering:
      supportsSpeakerCount &&
      providerModel.includes('assembly') &&
      !providerModel.includes(TWO_STAGE_CLUSTERING_UNSUPPORTED_MODEL),
  };
};
